import { MONERIS } from './index';
import { Action } from '../action';

export class MonerisHydrateAction implements Action {
	readonly type = MONERIS.HYDRATE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
